var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_arrow_left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.26723 7.62758C2.25898 7.63481 2.25092 7.64237 2.24305 7.65023C2.20121 7.69207 2.16834 7.73948 2.14443 7.79007C2.05502 7.97611 2.08743 8.20603 2.24166 8.36026C2.25492 8.37352 2.26874 8.38588 2.28305 8.39734L6.13214 12.2464C6.3274 12.4417 6.64398 12.4417 6.83924 12.2464C7.03451 12.0512 7.03451 11.7346 6.83924 11.5393L3.79991 8.49999H13.4999C13.7761 8.49999 13.9999 8.27613 13.9999 7.99999C13.9999 7.72385 13.7761 7.49999 13.4999 7.49999H3.80904L6.83786 4.47117C7.03312 4.27591 7.03312 3.95932 6.83786 3.76406C6.64259 3.5688 6.32601 3.5688 6.13075 3.76406L2.26723 7.62758Z",
    fill: "black",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowLeft);
export default __webpack_public_path__ + "static/media/ic_arrow_left.100f0e8a2f2923ab4fbe5a197c9d29c2.svg";
export { ForwardRef as ReactComponent };